import { css } from '@emotion/css';

const temporalToolbarButtonRules = {
  appearance: 'none',
  alignItems: 'center',
  background: 'var(--streamlain-background-primary-color)',
  border: '1px solid var(--streamlain-border-color)',
  borderRadius: '4px',
  color: 'var(--streamlain-text-primary-color)',
  cursor: 'pointer',
  display: 'inline-flex',
  fontSize: 'var(--streamlain-font-xs)',
  gap: '6px',
  height: '30px',
  justifyContent: 'center',
  lineHeight: 1,
  padding: '0 10px',
  userSelect: 'none',
  transition: 'background 0.12s ease-out, border-color 0.12s ease-out',

  '&:hover': {
    background: 'var(--streamlain-hover-color)',
    borderColor: 'var(--streamlain-primary-color)',
  },

  '&:disabled': {
    cursor: 'not-allowed',
    opacity: 0.5,
  },

  '&&&[data-active=true]': {
    background: 'var(--streamlain-v2-button-primary)',
    borderColor: 'var(--streamlain-v2-button-primary)',
    color: 'var(--streamlain-v2-button-pureWhiteText)',
  },
} as const;

export const temporalToolbarStyle = css({
  alignItems: 'center',
  background: 'var(--streamlain-background-primary-color)',
  borderBottom: '1px solid var(--streamlain-border-color)',
  display: 'flex',
  flexWrap: 'wrap',
  gap: '6px',
  justifyContent: 'space-between',
  minWidth: 0,
  padding: '8px 16px',

  '&[data-bottom-border="false"]': {
    borderBottom: 'none',
  },
});

export const temporalToolbarGroupStyle = css({
  alignItems: 'center',
  display: 'flex',
  flexWrap: 'wrap',
  gap: '6px',
  minWidth: 0,
});

export const temporalToolbarButtonStyle = css(temporalToolbarButtonRules);

export const temporalToolbarIconButtonStyle = css({
  ...temporalToolbarButtonRules,
  minWidth: '30px',
  padding: 0,
  width: '30px',
});

export const temporalToolbarPrimaryButtonStyle = css({
  ...temporalToolbarButtonRules,
  '&&&': {
    background: 'var(--streamlain-v2-button-primary)',
    borderColor: 'var(--streamlain-v2-button-primary)',
    color: 'var(--streamlain-v2-button-pureWhiteText)',
  },
});

export const temporalToolbarRangeTitleStyle = css({
  color: 'var(--streamlain-text-primary-color)',
  fontSize: '14px',
  fontWeight: 600,
  minWidth: 0,
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
});
